import { useSelector } from "react-redux";
import { useGetBuckeyeLinkDataQuery, useGetPreferencesQuery } from "../../services/graphql/api";
import { selectQuickLinks } from "../../services/graphql/slices/buckeye-link";
import { parsePreferredQuickLinksFromDataResponse } from "../../services/data-sources/aws-lambda/preferences";

const maxToRender = 25

const selectLinks = (state) => {
  let res = {
    custom: false,
    quickLinks: selectQuickLinks(state).filter(o => o.title && o.link)
  }
  res.quickLinks = (res.quickLinks ?? []).slice(0, maxToRender)
  return res
}

export const useQuickLinksWithPreferences = () => {
  const queryResponse = useGetBuckeyeLinkDataQuery()
  const { data: verifiedLinks, ...preferences} = useGetPreferencesQuery(undefined, {
    selectFromResult: ({ data, isLoading, isSuccess }) => {
      return {
        data: parsePreferredQuickLinksFromDataResponse(data),
        isLoading,
        isSuccess
      }
    }
  })

  const { custom, quickLinks } = useSelector(state => {
    let res = selectLinks(state)
    res.custom = verifiedLinks?.length >= 3
    if(res.custom) {
      res.quickLinks = verifiedLinks
    }

    return res
  })
  

  const isLoading = preferences?.isLoading || queryResponse?.isLoading
  const isSuccess = preferences?.isSuccess || queryResponse?.isSuccess
  return {
    isLoading,
    isSuccess,
    custom,
    links: quickLinks ?? []
  }
}

function useQuickLinks() {
  const queryResponse = useGetBuckeyeLinkDataQuery()
  const { custom, quickLinks } = useSelector(selectLinks)

  return {
    isLoading: queryResponse?.isLoading,
    isSuccess: queryResponse?.isSuccess,
    custom,
    links: quickLinks ?? []
  }
}

export default useQuickLinks;
